import { z } from '@customerio/hydra-validation';

/**
 * The Ad Audiences tab's search. `audienceId` and `audienceAction` name the manage modal to open
 * and are read through nuqs, so they pass through at whatever type the router parsed them as: a
 * coercion here would be written back to the address bar as a quoted id.
 *
 * `isAdding` arrives on links from the Usage tab of the embedded app, which once opened the create
 * flow with it. Nothing opens that flow from here, so it is accepted and dropped.
 *
 * The object is loose so global params the tab does not own (`masq_account_id`, …) survive.
 */
export const segmentAudiencesSearchSchema = z.looseObject({
  audienceId: z.unknown().optional(),
  audienceAction: z.unknown().optional(),
  isAdding: z
    .unknown()
    .optional()
    .transform(() => undefined),
});
